import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import type FavoritesDestinationsIndex from "@travily/types/pages/FavoritesDestinationsIndex";
import { useFavoritesTabs } from "@/hooks/use-favorites-tabs";
import { usePageFavorites } from "@/hooks/use-search-favorites";
import { PageFrame } from "@/layouts/page-frame";
import { FavoritesFrame } from "@/pages/favorites/components/FavoritesFrame";
import { DestinationFavorites } from "./destinations.view";

const FavoritesDestinationsPage = ({ destinations }: FavoritesDestinationsIndex) => {
  const { getFavorited, onFavoriteToggle } = usePageFavorites();
  const tabs = useFavoritesTabs();

  return (
    <PageFrame>
      <Head title={t("web.favorites.destinations.meta_title")} />
      <FavoritesFrame currentTab="destinations" tabs={tabs} title={t("web.favorites.index.title")}>
        <DestinationFavorites
          destinations={destinations}
          empty={{
            description: t("web.favorites.index.empty.destinations.description"),
            title: t("web.favorites.index.empty.destinations.title"),
          }}
          getFavorited={getFavorited}
          onFavoriteToggle={onFavoriteToggle}
        />
      </FavoritesFrame>
    </PageFrame>
  );
};

export default FavoritesDestinationsPage;
